import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AnimatedBackground from '@/components/AnimatedBackground';
import { useLanguage } from '@/App';
import { Calendar, Users, Sparkles, Building2, Instagram, ArrowRight } from 'lucide-react';

const CorporateEventsPage = () => {
  const { language } = useLanguage();

  const content = {
    tr: {
      title: 'Kurumsal Etkinlik Yönetimi',
      description: 'Markanızın fiziksel buluşmalarını unutulmaz deneyimlere dönüştürüyoruz. Marka lansmanları, şirket içi kutlamalar, motivasyon toplantıları, müşteri buluşmaları, stant ve fuar katılımları gibi fiziksel etkinliklerinizi tasarlıyor ve dijital kampanyalarınızla entegre ederek hayata geçiriyoruz.',
      instagram: 'Instagram',
      instagramText: 'Kurumsal Etkinlik Yönetimi',
      instagramCta: 'Sayfamızı Ziyaret Edin',
      services: [
        {
          title: 'Marka Lansmanları',
          description: 'Yeni ürün ve hizmetlerinizi etkileyici etkinliklerle tanıtıyoruz.'
        },
        {
          title: 'Şirket İçi Kutlamalar',
          description: 'Ekibinizin motivasyonunu artıran özel organizasyonlar düzenliyoruz.'
        },
        {
          title: 'Müşteri Buluşmaları',
          description: 'Müşterilerinizle bağınızı güçlendiren etkinlikler organize ediyoruz.'
        },
        {
          title: 'Fuar & Stant Katılımları',
          description: 'Markanızı fuarlarda en iyi şekilde temsil ediyoruz.'
        }
      ]
    },
    en: {
      title: 'Corporate Event Management',
      description: 'Transforming your brand\'s physical gatherings into unforgettable experiences. We design physical events such as brand launches, internal celebrations, motivation meetings, customer meetings, booth and fair participations, and integrate them with your digital campaigns to bring them to life.',
      instagram: 'Instagram',
      instagramText: 'Corporate Event Management',
      instagramCta: 'Visit Our Page',
      services: [
        {
          title: 'Brand Launches',
          description: 'We introduce your new products and services with impressive events.'
        },
        {
          title: 'Internal Celebrations',
          description: 'We organize special events that boost your team\'s motivation.'
        },
        {
          title: 'Customer Meetings',
          description: 'We organize events that strengthen your connection with customers.'
        },
        {
          title: 'Fair & Booth Participations',
          description: 'We represent your brand at fairs in the best way possible.'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-black relative flex flex-col">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navbar />
        
        {/* Hero Section */}
        <div className="flex-1 px-4 py-20 pt-32 bg-black bg-opacity-75">
          <div className="max-w-6xl mx-auto">
            {/* Title with slide-in animation */}
            <div className="text-center mb-12 animate-slide-in-left">
              <h1 className="text-3xl md:text-4xl text-white mb-8 font-bold">
                {t.title}
              </h1>
              <p className="text-lg md:text-xl text-[#FFDD59] max-w-4xl mx-auto leading-relaxed mb-4">
                Markanızın fiziksel buluşmalarını unutulmaz deneyimlere dönüştürüyoruz.
              </p>
              <p className="text-base md:text-lg text-[#FFDD59] max-w-4xl mx-auto leading-relaxed">
                Marka lansmanları, şirket içi kutlamalar, motivasyon toplantıları, müşteri buluşmaları, stant ve fuar katılımları gibi fiziksel etkinliklerinizi tasarlıyor ve dijital kampanyalarınızla entegre ederek hayata geçiriyoruz.
              </p>
            </div>

            {/* Service Cards */}
            <div className="grid md:grid-cols-2 gap-8 mt-16">
              {t.services.map((service, index) => {
                const icons = [Calendar, Users, Sparkles, Building2];
                const Icon = icons[index];
                
                return (
                  <div 
                    key={index}
                    className="bg-gradient-to-br from-[#FFDD59] to-yellow-400 p-8 rounded-2xl transform hover:scale-105 transition shadow-xl"
                  >
                    <Icon className="mb-4" size={48} color="black" />
                    <h3 className="text-2xl font-bold text-black mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-800 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Instagram Link Section */}
            <div className="mt-16 flex justify-center">
              <div className="bg-gray-900 border-2 border-[#FFDD59] text-white rounded-xl p-6 transform hover:scale-105 transition shadow-2xl text-center max-w-md">
                <Instagram className="mx-auto mb-3" size={40} color="#FFDD59" />
                <h3 className="text-xl font-bold text-[#FFDD59] mb-2">{t.instagram}</h3>
                <p className="text-gray-300 text-sm mb-4">{t.instagramText}</p>
                <a 
                  href="https://www.instagram.com/personaevent" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-full py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-base font-bold rounded-lg hover:from-purple-600 hover:to-pink-600 transition flex items-center justify-center gap-2"
                >
                  {t.instagramCta}
                  <ArrowRight size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default CorporateEventsPage;
